<script setup>
import {defineProps, defineEmits} from "vue";
import LinhaDeContasAReceber from "./LinhaDeContasAReceber/LinhaDeContasAReceber.vue";

//==================================================================//
//========================= Props / Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
]);

const emits = defineEmits([
    "update:alteraContaAReceber",
]);

//==================================================================//
//================== Altera Conta a Receber ========================//
//==================================================================//

const alteraContaAReceber = (update)=>{

    emits('update:alteraContaAReceber',update);

};

</script>

<template>

    <div class="c-table__body">

        <LinhaDeContasAReceber v-for="contaAReceber in props?.dado?.contasAReceber"
            :key="contaAReceber.id"
            :dado="props?.dado"
            :contaAReceber="contaAReceber"
            @update:alteraContaAReceber="alteraContaAReceber"
        ></LinhaDeContasAReceber>

    </div>

</template>

<style scoped>

.c-table__body{
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
}

</style>